import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  postInvalidateBetsAfterResult,
  postInvalidatePnl,
  type InvalidateBetsBody,
  type InvalidatePnlBody,
} from '@/api/map/plInvalidate'
import { keys } from '@/api/hooks/shared/keys'

/** Lab Invalidate P&L — void settlement P&L via CM-API → Result-API. */
export function useInvalidatePnl() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: InvalidatePnlBody) => postInvalidatePnl(body),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: keys.oneAccount(vars.accountId) })
      void qc.invalidateQueries({ queryKey: ['pl-statement'] })
    },
  })
}

/** Lab Invalid Bets after result — reverse settlement + mark order ids. */
export function useInvalidateBetsAfterResult() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: InvalidateBetsBody) => postInvalidateBetsAfterResult(body),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: keys.oneAccount(vars.accountId) })
      void qc.invalidateQueries({ queryKey: ['pl-statement'] })
    },
  })
}
